export default "__VITE_ASSET__CVjs$eqC__"